module.exports = __webpack_public_path__ + "img/mr.76ad0dee.svg";